import "./PublicFeed.css";
import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { AiFillDelete, AiFillHeart } from 'react-icons/ai';
import Purchase from "./Purchase";


class PublicFeed extends Component {
    state = {
        loading: false,
        openModal: false,
        postIndex: null,
        purchaseModalStatus: false,
    }

    handleTopImgClick = (index) => {
        this.setState({ openModal: true, postIndex: index });
    }

    handleCloseModal = (e) => {
        if (e.target.getAttribute('name') === "modal") {
            this.setState({ openModal: false, postIndex: null })
        }

    }

    setPurchaseModal = (status) => {
        this.setState({ purchaseModalStatus: status });
    }


    componentDidMount() {
        this.props.getPosts(this.props.postHistory[0]._id, "newest")
    }

    render() {
        let post = null;
        if (this.state.postIndex !== null) {
            post = this.props.topPosts[this.state.postIndex];
        }

        return (
            <>
                <div style={{ height: "5vh" }}>
                    <Header
                        credits={this.props.user.credits}
                        setPurchaseModal={this.setPurchaseModal}
                        email={this.props.auth_user.email}
                        auth0={this.props.auth0}
                        history={this.props.history}
                        deleteAccount={this.props.deleteAccount}
                    />
                </div>
                <div
                    name={"modal"}
                    className="top-img-modal"
                    style={{ display: this.state.openModal ? "flex" : "none" }}
                    onClick={this.handleCloseModal}
                >

                    {post !== null &&
                        <div className="feed-item">
                            <img className="feed-img" src={post.imageHash} alt={post.prompt} />
                            <p>{post.prompt}</p>
                            {/* <p>{`By: ${post.email}`}</p> */}
                            <div className="conainer-tools">
                                <div>
                                    <AiFillHeart
                                        size={30}
                                        color={post.liked ? "#d4204a" : "gray"}
                                        style={{ verticalAlign: "middle", disbaled: this.state.loading }}
                                        onClick={this.props.handleLikes.bind(this, post._id)}
                                    />
                                    {` ${post.likes} Likes`}
                                </div>
                            </div>

                        </div>
                    }
                </div>


                <div className="container-feed">

                    <div className="feed">
                        <div className="top-posts-container">
                            {this.props.topPosts.map((item, key) =>
                                <div className="top-posts-item" key={key}>
                                    <img
                                        className="top-posts-img"
                                        src={item.imageHash} alt={item.prompt}
                                        onClick={this.handleTopImgClick.bind(this, key)} />
                                </div>
                            )}
                            {/* <div className="top-posts-text">Top generated images by likes</div> */}


                        </div>

                        {this.props.postHistory.map((item, index) =>
                            <div className="feed-item" key={index}>
                                <img className="feed-img" src={item.imageHash} alt={`Feed post ${index}`} />
                                <p>{item.prompt} {(("mode" in item) && <font color="#345beb">{" #" + item.mode}</font>)}</p>
                                {/* <p>{`By: ${item.email}`}</p> */}
                                <div className="conainer-tools">

                                    <div>
                                        <AiFillHeart
                                            size={30}
                                            color={item.liked ? "#d4204a" : "#a8a5a6"}
                                            style={{ verticalAlign: "middle", disbaled: this.state.loading }}
                                            onClick={this.props.handleLikes.bind(this, item._id)}
                                        />
                                        {` ${item.likes} Likes`}
                                    </div>



                                    {item.isOwner &&
                                        <AiFillDelete
                                            size={30}
                                            style={{ verticalAlign: "middle", disbaled: this.state.loading }}
                                            onClick={this.props.handleDeletePost.bind(this, item._id)}
                                        />
                                    }

                                </div>

                            </div>

                        )}

                        <div style={{ width: "100%" }}>
                            <button
                                className="button-load"
                                onClick={() => this.props.getPosts(this.props.postHistory.slice(-1)[0]._id, "oldest")}>
                                Load more
                            </button>
                        </div>
                    </div>

                </div>
                <Purchase
                    open={this.state.purchaseModalStatus}
                    onClose={() => { this.setState({ purchaseModalStatus: false }) }}
                    token={this.props.token}
                    updateUser={this.props.updateUser}
                />
                <Footer />
            </>

        );
    }
}




export default PublicFeed;













